export const rootURL = '/';
export const transactionAnalyserURL = '/transactionAnalyser';
export const widgetTestUrl = '/widget';
export const logsURL = '/admin/logs';
export const adminAccessURL = '/admin/access';
export const adminBatchURL = '/admin/batch';
export const cacheManagementURL = '/admin/cacheManagement';
export const pluginManagementURL = '/admin/pluginManagement';